export default [
  { name: 'Text', value: 'text' },
  { name: 'Text Area', value: 'text-area' },
  { name: 'Toggle', value: 'toggle' }
]
